import ApiHandler from "./ApiHandler";

const VerifyEmail = {
  getVerifyEmail: async (token) => await ApiHandler.i.get(`/verify-email/${token}`),
};

export default VerifyEmail;